module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/operator/toPromise","commonjs2":"rxjs/add/operator/toPromise","amd":"rxjs/add/operator/toPromise"}
// module id = 10
// module chunks = 0 1